import borders from '@assets/theme/base/borders';
import boxShadows from '@assets/theme/base/boxShadows';
import breakpoints from '@assets/theme/base/breakpoints';

// Material Home 2 React base styles
import colors from '@assets/theme/base/colors';
import typography from '@assets/theme/base/typography';
import appBar from '@assets/theme/components/appBar';
import avatar from '@assets/theme/components/avatar';
import button from '@assets/theme/components/button';
import buttonBase from '@assets/theme/components/buttonBase';

// Material Home 2 React components base styles for @mui material components
import card from '@assets/theme/components/card';
import cardContent from '@assets/theme/components/card/cardContent';
import cardMedia from '@assets/theme/components/card/cardMedia';
import link from '@assets/theme/components/link';
import menu from '@assets/theme/components/menu';
import menuItem from '@assets/theme/components/menu/menuItem';
import slider from '@assets/theme/components/slider';
import stepper from '@assets/theme/components/stepper';
import step from '@assets/theme/components/stepper/step';
import stepConnector from '@assets/theme/components/stepper/stepConnector';
import stepIcon from '@assets/theme/components/stepper/stepIcon';
import stepLabel from '@assets/theme/components/stepper/stepLabel';
import tabs from '@assets/theme/components/tabs';
import tab from '@assets/theme/components/tabs/tab';
import tooltip from '@assets/theme/components/tooltip';
//import globals from "@assets/theme/base/globals";
// Material Home 2 React helper functions
import scrollbarStyles from '@assets/theme/base/scrollbarStyles.jsx';
import boxShadow from '@assets/theme/functions/boxShadow';
import hexToRgb from '@assets/theme/functions/hexToRgb';
import linearGradient from '@assets/theme/functions/linearGradient';
import pxToRem from '@assets/theme/functions/pxToRem';
import rgba from '@assets/theme/functions/rgba';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = {
    breakpoints: { ...breakpoints },
    palette: { ...colors },
    typography: { ...typography },
    boxShadows: { ...boxShadows },
    borders: { ...borders },
    functions: {
        boxShadow,
        hexToRgb,
        linearGradient,
        pxToRem,
        rgba
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                //...globals
            }
        },
        MuiUseMediaQuery: {
            defaultProps: {
                noSsr: true
            }
        },
        MuiFormHelperText: {
            defaultProps: {
                sx: {
                    fontSize: '0.85em !important',
                    color: 'black.main'
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent !important',
                    ...scrollbarStyles
                }
            },
            defaultProps: {
                sx: {
                    '& .MuiButtonBase-root.MuiMenuItem-root': {
                        mb: 0.5,
                        px: 3,
                        py: 1
                    }
                }
            }
        },
        MuiButtonBase: { ...buttonBase },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    '& :hover, & .Mui-focusVisible': {
                        outlineOffset: '-3.5px'
                    },
                    '& .Mui-focusVisible': {
                        outline: `3px solid ${colors.secondary.dark}`
                    }
                }
            }
        },
        MuiButton: { ...button },
        MuiIconButton: {
            defaultProps: {
                color: 'text'
            },
            styleOverrides: {
                root: {
                    '& .tabler-icon': {
                        fontSize: pxToRem(18),
                        width: pxToRem(18),
                        height: pxToRem(18)
                    }
                }
            }
        },
        MuiToggleButton: {
            ...button,
            styleOverrides: {
                ...button.styleOverrides,
                root: {
                    ...button.styleOverrides.root,
                    'borderColor': colors.black.main,
                    '& svg': {
                        marginRight: '6px'
                    },
                    'color': colors.black.main,
                    '&.Mui-selected': {
                        'color': colors.secondary.main,
                        'backgroundColor': colors.black.main,
                        '&:hover': {
                            backgroundColor: colors.secondary.main,
                            color: colors.black.main
                        }
                    },
                    '&:hover': {
                        backgroundColor: colors.secondary.main,
                        color: colors.black.main
                    }
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    '& svg': {
                        color: colors.black.main
                    },
                    ':hover, :focus': {
                        zIndex: 2, // allow the outline to appear above the other elements,
                        outlineOffset: '-1px'
                    }
                }
            }
        },
        MuiCard: { ...card },
        MuiCardMedia: { ...cardMedia },
        MuiCardContent: { ...cardContent },
        MuiMenu: { ...menu },
        MuiMenuItem: { ...menuItem },
        MuiSlider: { ...slider },
        MuiAvatar: { ...avatar },
        MuiTooltip: { ...tooltip },
        MuiAppBar: { ...appBar },
        MuiTabs: { ...tabs },
        MuiTab: { ...tab },
        MuiStepper: { ...stepper },
        MuiStep: { ...step },
        MuiStepConnector: { ...stepConnector },
        MuiStepLabel: { ...stepLabel },
        MuiStepIcon: { ...stepIcon },
        MuiLink: { ...link },
        MuiBox: {
            styleOverrides: {
                root: {
                    ...scrollbarStyles
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    ...scrollbarStyles
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: borders.borderRadius.xl,
                    boxShadow: boxShadows.xxl
                },

                paperFullScreen: {
                    borderRadius: 0
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    ...scrollbarStyles
                }
            }
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    'borderColor': colors.primary.light,
                    'borderWidth': '1.5px',
                    '&.Mui-selected': {
                        backgroundColor: colors.primary.main + '!important',
                        color: colors.white.main + '!important'
                    }
                }
            }
        }
    }
};

theme = createTheme(theme);
theme = responsiveFontSizes(theme);

export default theme;
